import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=a60e1676&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a60e1676')) {
      api.createRecord('a60e1676', component.options)
    } else {
      api.reload('a60e1676', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=a60e1676&", function () {
      api.rerender('a60e1676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KHYc7o3F7gYz/JS/comp/cancellationPolicy.vue"
export default component.exports